/**
 * Privacy Policy Page
 * GDPR compliant privacy policy for HipotecaFácil
 */

import { renderNavbar } from '../components/navbar.js';
import { renderFooter } from '../components/footer.js';

export function renderPrivacy(container) {
  container.innerHTML = `
    ${renderNavbar()}
    
    <main class="legal-page">
      <div class="container">
        <div class="legal-content animate-fadeIn">
          <h1 class="legal-title">Política de Privacidad</h1>
          <p class="legal-updated">Última actualización: 9 de enero de 2026</p>
          
          <section class="legal-section">
            <h2>1. Responsable del Tratamiento</h2>
            <p>
              <strong>Identidad:</strong> HipotecaFácil<br>
              <strong>Email de contacto:</strong> privacidad@hipotecafacil.es<br>
              <strong>Finalidad del tratamiento:</strong> Prestación del servicio contratado
            </p>
          </section>
          
          <section class="legal-section">
            <h2>2. Datos que Recopilamos</h2>
            <p>Recopilamos los siguientes datos personales:</p>
            
            <h3>2.1 Datos de registro</h3>
            <ul>
              <li>Dirección de correo electrónico</li>
              <li>Contraseña (almacenada de forma cifrada)</li>
              <li>Método de autenticación (email o Google)</li>
            </ul>
            
            <h3>2.2 Datos de perfil financiero</h3>
            <ul>
              <li>Edad</li>
              <li>Situación laboral</li>
              <li>Ingresos mensuales aproximados</li>
              <li>Ahorros actuales aproximados</li>
              <li>Comunidad Autónoma de residencia</li>
            </ul>
            
            <h3>2.3 Datos de uso</h3>
            <ul>
              <li>Gastos mensuales introducidos</li>
              <li>Progreso en la guía hipotecaria</li>
              <li>Preferencias de navegación</li>
            </ul>
            
            <h3>2.4 Datos de pago</h3>
            <p>
              Los datos de pago (tarjeta de crédito, etc.) son procesados directamente por 
              Stripe y nunca almacenamos estos datos en nuestros servidores.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>3. Base Legal del Tratamiento</h2>
            <ul>
              <li><strong>Ejecución del contrato:</strong> Para proporcionar los servicios contratados</li>
              <li><strong>Consentimiento:</strong> Para el envío de comunicaciones comerciales (si aplica)</li>
              <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios y prevenir fraudes</li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>4. Finalidad del Tratamiento</h2>
            <p>Utilizamos tus datos para:</p>
            <ul>
              <li>Gestionar tu cuenta de usuario</li>
              <li>Proporcionar cálculos y recomendaciones personalizadas</li>
              <li>Procesar pagos de suscripción</li>
              <li>Enviarte notificaciones importantes del servicio</li>
              <li>Mejorar y personalizar tu experiencia</li>
              <li>Cumplir con obligaciones legales</li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>5. Conservación de Datos</h2>
            <p>
              Conservamos tus datos mientras mantengas una cuenta activa. Tras la cancelación 
              de tu cuenta, los datos serán eliminados en un plazo máximo de 30 días, salvo 
              que existan obligaciones legales que requieran su conservación.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>6. Destinatarios de los Datos</h2>
            <p>Podemos compartir tus datos con:</p>
            <ul>
              <li><strong>Firebase (Google):</strong> Para autenticación de usuarios</li>
              <li><strong>Stripe:</strong> Para procesamiento de pagos</li>
              <li><strong>Proveedores de hosting:</strong> Para el almacenamiento de datos</li>
            </ul>
            <p>
              Todos nuestros proveedores cumplen con el RGPD y tienen suscritos los 
              correspondientes contratos de procesamiento de datos.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>7. Tus Derechos (RGPD)</h2>
            <p>De acuerdo con el Reglamento General de Protección de Datos, tienes derecho a:</p>
            <ul>
              <li><strong>Acceso:</strong> Solicitar una copia de tus datos personales</li>
              <li><strong>Rectificación:</strong> Corregir datos inexactos o incompletos</li>
              <li><strong>Supresión:</strong> Solicitar la eliminación de tus datos ("derecho al olvido")</li>
              <li><strong>Portabilidad:</strong> Recibir tus datos en un formato estructurado</li>
              <li><strong>Oposición:</strong> Oponerte al tratamiento de tus datos</li>
              <li><strong>Limitación:</strong> Solicitar la restricción del tratamiento</li>
            </ul>
            <p>
              Para ejercer cualquiera de estos derechos, contacta con nosotros en: 
              <strong>privacidad@hipotecafacil.es</strong>
            </p>
          </section>
          
          <section class="legal-section">
            <h2>8. Seguridad</h2>
            <p>
              Implementamos medidas de seguridad técnicas y organizativas para proteger 
              tus datos, incluyendo:
            </p>
            <ul>
              <li>Cifrado de datos en tránsito (HTTPS/TLS)</li>
              <li>Contraseñas almacenadas con hash seguro</li>
              <li>Acceso restringido a datos personales</li>
              <li>Monitorización y detección de intentos de intrusión</li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>9. Cookies</h2>
            <p>
              Para información detallada sobre el uso de cookies, consulta nuestra 
              <a href="/cookies" data-link style="color: var(--primary-600);">Política de Cookies</a>.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>10. Cambios en esta Política</h2>
            <p>
              Nos reservamos el derecho de modificar esta política. Cualquier cambio 
              será notificado a través de la aplicación o por email.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>11. Autoridad de Control</h2>
            <p>
              Si consideras que el tratamiento de tus datos no es adecuado, puedes 
              presentar una reclamación ante la 
              <a href="https://www.aepd.es" target="_blank" rel="noopener" style="color: var(--primary-600);">
                Agencia Española de Protección de Datos (AEPD)
              </a>.
            </p>
          </section>
          
          <div class="legal-footer">
            <a href="/" data-link class="btn btn-secondary">
              <i data-feather="arrow-left"></i>
              Volver al inicio
            </a>
          </div>
        </div>
      </div>
    </main>
    
    ${renderFooter()}
  `;
}
